import type { PricingTierId } from "./siteContent";

export const PRICING_TIER_PRICES_RUB: Record<PricingTierId, number> = {
  basic: 700,
  master: 1500,
  legend: 10_000,
};

export const PRICING_TIER_LICENSE: Record<
  PricingTierId,
  { years: number; devices: number }
> = {
  basic: { years: 1, devices: 3 },
  master: { years: 2, devices: 5 },
  legend: { years: 99, devices: 15 },
};
